import { useStore } from '@/hooks/useStore';
import { useLocation, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Button } from '@/components/common/Button';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/configs/constants';
import { toastify } from '@/utils/toastify';
import Header from '@/components/layout/Header';
import mapPinIcon from '@/assets/images/pngs/MapPin.png';
import { Item, OwnerItem } from '@/types/item';
import ItemLocationList from '@/components/common/ItemLocationList';
import { flowResult, set } from 'mobx';

export default observer(function ListLocationItems() {
    // store
    const {
        itemsStore: { putListItemsAssagined, setItemLocations, setItemToSetLocation }
    } = useStore();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const items: OwnerItem[] = JSON.parse(location.state.items) || [];
    const [otp, setOtp] = useState<string>('');
    const [timeDown, setTimeDown] = useState<number>(60);
    useEffect(() => {
        if (timeDown <= 0) return; // Nếu thời gian đã hết thì không làm gì nữa

        const timer = setInterval(() => {
            setTimeDown(prevTime => prevTime - 1); // Giảm thời gian mỗi giây
        }, 1000);

        // Dọn dẹp interval khi component bị unmount hoặc khi timeLeft = 0
        return () => clearInterval(timer);
    }, [timeDown]); // Chạy lại effect mỗi khi timeLeft thay đổi

    const goBack = () => {
        setItemToSetLocation(null);
        navigate(ROUTES.listItems.href);
    };

    const handleSetting = async () => {
        const dataEdited = items.map(e => ({
            id: e.id,
            latitude: e.latitude,
            longitude: e.longitude,
            address: e.address
        }));
        const res = await flowResult(putListItemsAssagined({ items: dataEdited }));
        if (res) {
            setItemLocations(res);
            navigate(ROUTES.home.href);
        }
    };

    const handleSetLocation = (item) => {
        setItemToSetLocation(item, items);
        navigate(ROUTES.home.href);
    };

    return (
        <div className='w-screen h-screen flex flex-col justify-start pt-[72px]'>
            <Header title={t('text.listItems')} goBackFunction={goBack} />
            <div className='h-[calc(100vh-72px-32px)] bg-bgMain flex flex-col justify-between content-center px-[16px]'>
                <p className='text-[13px] text-gray pt-[24px]'>{t('text.selectLocation')}</p>
                <ItemLocationList handleAddLocation={item => handleSetLocation(item)} items={items} className='w-full h-full bg-bgMain overflow-y-scroll scrollbar-hide py-[12px]' />
                <div className='h-[72px] w-full  flex justify-between items-center space-x-[10px]'>
                    <Button
                        variant='white'
                        className=' w-full h-[48px] rounded-[10px]'
                        onClick={goBack}
                    >
                        {t('text.cancel')}
                    </Button>
                    <Button
                        variant='main'
                        className=' w-full h-[48px] rounded-[10px]'
                        onClick={handleSetting}
                        disabled={!items || items.length === 0 || items.filter(e => e.latitude === null).length > 0}
                    >
                        <img src={mapPinIcon} alt={mapPinIcon} className='w-4 h-4 mr-1' />
                        {t('text.addPosition')}
                    </Button>
                </div>
            </div>

        </div>
    );
});
